import React from 'react';
import { useIntl } from 'react-intl';
import { WizardStep, WIZARD_STEPS } from './consts';
import {
  StyledStepper,
  StyledStepperItem,
  StyledStepperButton,
  StyledStepperIndex,
  StyledStepperLabel,
  StyledStepperOptional,
} from './styles';

interface WizardStepperProps {
  current: WizardStep;
  onJump: (step: WizardStep) => void;
}

const WizardStepper: React.FC<WizardStepperProps> = ({ current, onJump }) => {
  const intl = useIntl();

  return (
    <StyledStepper aria-label='Order steps' data-tour='wizard-stepper'>
      {WIZARD_STEPS.map((step, index) => {
        const active = step.key === current;
        const done = step.key < current;
        return (
          <StyledStepperItem key={step.key}>
            <StyledStepperButton
              type='button'
              active={active}
              done={done}
              aria-current={active ? 'step' : undefined}
              onClick={() => onJump(step.key)}
            >
              <StyledStepperIndex active={active} done={done}>
                {done ? '✓' : index + 1}
              </StyledStepperIndex>
              <StyledStepperLabel>
                {intl.formatMessage({
                  id: step.labelId,
                  defaultMessage: step.defaultLabel,
                })}
              </StyledStepperLabel>
              {step.optional && (
                <StyledStepperOptional>
                  {intl.formatMessage({
                    id: 'orderWizard.step.optional',
                    defaultMessage: 'Optional',
                  })}
                </StyledStepperOptional>
              )}
            </StyledStepperButton>
          </StyledStepperItem>
        );
      })}
    </StyledStepper>
  );
};

export default WizardStepper;
